<footer class="pt-2">
  <div class="container p-5 footer-links pure-section border-pattern-bottom">
    <div class="grid pt-3">
      <div class="col-10 col-offset-1">
        <div class="grid pb-5">
          <div class="col-12 md:col-3">
            <img
              alt="BoMa"
              class="logo-block my-0 p-0"
              src="/assets/layout/images/brand/logo-h-dark-text.svg"
              width="120"
            />
            <ul class="social-network">
              <li>
                <a
                  class="twitter"
                  href="https://twitter.com/bomatoday"
                  target="_blank"
                >
                  <svg aria-hidden="true">
                    <use xlink:href="#social-twitter"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="facebook"
                  href="https://facebook.com/bomatradeyourway"
                  target="_blank"
                >
                  <svg aria-hidden="true">
                    <use xlink:href="#social-facebook"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="youtube"
                  href="https://www.youtube.com/@bomatradeyourway"
                  target="_blank"
                >
                  <svg aria-hidden="true">
                    <use xlink:href="#social-youtube"></use>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  class="instagram"
                  href="https://www.instagram.com/bomatradeyourway/"
                  target="_blank"
                >
                  <svg aria-hidden="true">
                    <use xlink:href="#social-instagram"></use>
                  </svg>
                </a>
              </li>
            </ul>
            <!--            <p>Get the Boma App</p>-->
            <!-- TODO ADD QR CODE-->

            <a
              class="app-button"
              href="https://play.google.com/store/apps/details?id=today.boma.app"
              target="_blank"
            >
              <img
                alt="Google Play Store Download"
                class="vendor-badge"
                src="assets/layout/images/vendors/google-play-badge.svg"
              />
            </a>

            <!--            <a href=''>-->
            <!--              <svg aria-hidden='true' class='vendor-badge apple'>-->
            <!--                <use xlink:href='#apple-badge'></use>-->
            <!--              </svg>-->
            <!--            </a>-->
          </div>
          <div class="col-4 md:col-3">
            <h3>Solutions For</h3>
            <ul>
              <li>
                <a [routerLink]="['/', 'trader']" href="javascript:void(0)"
                  >Shop Owner / Entrepreneur</a
                >
              </li>
              <li>
                <a [routerLink]="['/', 'supplier']" href="javascript:void(0)"
                  >Supplier</a
                >
              </li>
              <li>
                <a [routerLink]="['/', 'producer']" href="javascript:void(0)"
                  >Producer / Manufacturer</a
                >
              </li>
              <li>
                <a [routerLink]="['/', 'shoppers']" href="javascript:void(0)"
                  >Shopper</a
                >
              </li>
            </ul>
          </div>
          <div class="col-4 md:col-3">
            <h3>Support</h3>
            <ul>
              <li><a href="#">Enterprise Overview</a></li>
              <li><a href="#">Enterprise Sign up</a></li>
            </ul>
            <h3>Terms & Policies</h3>
            <ul>
              <li>
                <a
                  [routerLink]="['/', 'terms-and-conditions']"
                  href="javascript:void(0)"
                  >Terms and Conditions</a
                >
              </li>
              <li>
                <a
                  [routerLink]="['/', 'privacy-policy']"
                  href="javascript:void(0)"
                  >Privacy Policy</a
                >
              </li>
            </ul>
          </div>
          <div class="col-4 md:col-3">
            <h3>News</h3>
            <ul>
              <li>
                <a [routerLink]="['/', 'blog']" href="javascript:void(0)"
                  >Blog</a
                >
              </li>
            </ul>
            <h3>Socials</h3>
            <ul>
              <li>
                <a
                  class="facebook"
                  href="https://www.facebook.com/BoMaTradeYourWay/"
                  target="_blank"
                  >Facebook</a
                >
              </li>
              <li>
                <a
                  class="twitter"
                  href="https://twitter.com/bomatoday"
                  target="_blank"
                  >Twitter</a
                >
              </li>
              <li>
                <a
                  class="youtube"
                  href="https://www.youtube.com/@bomatradeyourway"
                  target="_blank"
                  >You Tube</a
                >
              </li>
              <li>
                <a
                  class="instagram"
                  href="https://www.instagram.com/bomatradeyourway/"
                  target="_blank"
                  >Instagram</a
                >
              </li>
              <li>
                <a
                  class="facebook"
                  href="https://www.linkedin.com/company/10548646"
                  target="_blank"
                  >LinkdIn</a
                >
              </li>
            </ul>
          </div>
        </div>

        <div class="grid footer-bar py-3">
          <div class="col-12 md:col-3">
            &copy; 2022 <a href="https://taptapsol.com">Tap Tap Solutions</a>
          </div>
          <div class="col-12 md:col-3">
            <a href="https://dpogroup.com/"
              ><img
                alt="Payment methods Via, Mastercard processed securely by PayGate a DPO Company"
                class="payment-methods"
                src="/assets/layout/images/vendors/PayGate-Card-Brand-Logos-PayGate.png"
            /></a>
          </div>
          <div class="col-12 md:col-6 text-right">
            <a
              [routerLink]="['/', 'about-boma']"
              class="ml-3"
              href="javascript:void(0)"
              >About</a
            >
            <a
              [routerLink]="['/', 'careers']"
              class="ml-3"
              href="javascript:void(0)"
              >Careers</a
            >
            <a
              [routerLink]="['/', 'privacy-policy']"
              class="ml-3"
              href="javascript:void(0)"
              >Privacy Policy</a
            >
            <a
              [routerLink]="['/', 'terms-and-conditions']"
              class="ml-3"
              href="javascript:void(0)"
              >Terms</a
            >
            <a
              [routerLink]="['/', 'contact']"
              class="ml-3"
              href="javascript:void(0)"
              >Contact</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</footer>

<svg class="svg-icons" xmlns="http://www.w3.org/2000/svg">
  <symbol id="andy-logo" viewBox="0 0 642 362">
    <path
      d="M478.33 109.291l53.428-92.607c3.06-5.321 1.241-12.12-4.07-15.196-5.31-3.066-12.11-1.242-15.184 4.073l-54.095 93.78c-41.372-18.895-87.833-29.42-137.41-29.42-49.575 0-96.04 10.525-137.408 29.42L129.496 5.56c-3.073-5.315-9.876-7.139-15.187-4.073-5.308 3.076-7.14 9.875-4.067 15.196l53.429 92.607C71.927 159.23 9.178 252.183 0 362h642c-9.187-109.817-71.937-202.77-163.67-252.709M468.497 217C483.113 217 495 229.109 495 243.994 495 258.882 483.113 271 468.498 271 453.887 271 442 258.882 442 243.994 442 229.109 453.887 217 468.498 217zM173.5 217c14.611 0 26.5 12.109 26.5 26.994C200 258.882 188.111 271 173.5 271c-14.614 0-26.5-12.118-26.5-27.006C147 229.109 158.886 217 173.5 217z"
      fill="#3DDC84"
      fill-rule="evenodd"
    ></path>
  </symbol>
  <symbol
    class="logo-android__logo-icon"
    id="android-logo"
    viewBox="0 0 898 160"
  >
    <path d="M2130-164h540v486h-540z" fill="none"></path>
    <path
      d="M2224.2 210.9c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2-7.2-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-8h13.2v59.9h-10.1c-1.7 0-3-1.4-3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.8-31.2M2269.2 200.2h13.2v8.1c3.6-6 10.4-9.3 18.2-9.3 13.9 0 22.9 9.8 22.9 25v36.1h-10.1c-1.7 0-3-1.4-3-3v-30.9c0-9.5-4.8-15.2-12.5-15.2-8.7 0-15.5 6.8-15.5 19.6v29.5h-10.1c-1.7 0-3-1.4-3-3v-56.9zM2365.1 210.9c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2-7.2-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-38h13.2v89.9H2385c-1.7 0-3-1.4-3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.8-31.2M2410.1 200.2h13.2v10.7c2.3-6.8 9-11.3 15.8-11.3 1.7 0 3.4.1 5.1.5v13.5c-2.3-.7-4.2-1.1-6.6-1.1-7.5 0-14.4 6.4-14.4 18.3V260h-10.1c-1.7 0-3-1.4-3-3v-56.8zM2479.7 249c10.5 0 18-8.3 18-18.9 0-10.7-7.4-18.9-18-18.9-10.7 0-18.1 8.3-18.1 18.9.1 10.7 7.5 18.9 18.1 18.9m0 12.3c-17.7 0-31.4-13.8-31.4-31.1 0-17.4 13.7-31.2 31.4-31.2s31.4 13.8 31.4 31.2c0 17.3-13.6 31.1-31.4 31.1M2521.8 200.2h13.2v59.9h-10.1c-1.7 0-3-1.4-3-3v-56.9zm6.6-13.1c-4.8 0-8.9-4-8.9-8.9 0-4.8 4.1-8.7 8.9-8.7 4.9 0 8.7 4 8.7 8.7 0 4.9-3.8 8.9-8.7 8.9M2577.1 210.9c-10.7 0-17.9 8.4-17.9 19.2s7.2 19.2 17.9 19.2 17.9-8.4 17.9-19.2c-.1-10.8-7.2-19.2-17.9-19.2m-2.4-11.9c8.6 0 15.8 4.4 19.2 9.2v-38h13.2v89.9H2597c-1.7 0-3-1.4-3-3v-5c-3.4 4.8-10.5 9.2-19.2 9.2-16.4 0-28.9-14-28.9-31.1s12.4-31.2 28.8-31.2"
    ></path>
    <path
      d="M2501.5-30.8l34.5-59.7c2-3.4.8-7.8-2.6-9.8s-7.8-.8-9.8 2.6l-34.9 60.4c-26.7-12.2-56.7-19-88.6-19-32 0-61.9 6.8-88.6 19l-34.9-60.4c-2-3.4-6.4-4.6-9.8-2.6s-4.6 6.4-2.6 9.8l34.5 59.7C2239.3 1.4 2198.9 61.3 2193 132h414c-5.9-70.7-46.4-130.6-105.5-162.8zM2304.7 73c-9.5 0-17.2-7.7-17.2-17.2s7.7-17.2 17.2-17.2 17.2 7.7 17.2 17.2-7.7 17.2-17.2 17.2zm190.6 0c-9.5 0-17.2-7.7-17.2-17.2s7.7-17.2 17.2-17.2 17.2 7.7 17.2 17.2-7.7 17.2-17.2 17.2z"
    ></path>
    <path d="M-72-75H974v309H-72z" fill="none"></path>
    <path
      d="M59.3 56.4c12.4 0 22.7 6.4 27.6 13.3V58.1h18.9v86.1H92.2c-3 0-5.4-2.4-5.4-5.4v-6.2c-4.8 7-15.1 13.4-27.5 13.4-23.6 0-41.5-20.2-41.5-44.8s17.9-44.8 41.5-44.8m3.4 17.2C47.4 73.6 37 85.7 37 101.2s10.3 27.6 25.7 27.6c15.3 0 25.7-12.1 25.7-27.6S78.1 73.6 62.7 73.6M127.3 58.1h19v11.7c5.2-8.6 15-13.4 26.2-13.4 20 0 32.9 14.1 32.9 36v51.8h-13.6c-3 0-5.4-2.4-5.4-5.4V95.5c0-13.6-6.9-21.9-17.9-21.9-12.6 0-22.2 9.8-22.2 28.2v42.4h-13.6c-3 0-5.4-2.4-5.4-5.4V58.1zM261.9 56.4c12.4 0 22.7 6.4 27.6 13.3V15.1h18.9v129.2h-13.6c-3 0-5.4-2.4-5.4-5.4v-6.2c-4.8 6.9-15.2 13.3-27.6 13.3-23.6 0-41.5-20.2-41.5-44.8.1-24.6 18-44.8 41.6-44.8m3.4 17.2c-15.3 0-25.7 12.1-25.7 27.6s10.3 27.6 25.7 27.6c15.3 0 25.7-12.1 25.7-27.6s-10.4-27.6-25.7-27.6M329.9 58.1h18.9v15.3c3.3-9.8 12.9-16.2 22.7-16.2 2.4 0 4.8.2 7.4.7v19.5c-3.3-1-6-1.6-9.5-1.6-10.9 0-20.7 9.1-20.7 26.4v42h-13.6c-3 0-5.4-2.4-5.4-5.4V58.1zM430.1 146c-25.5 0-45.1-19.8-45.1-44.8s19.6-44.8 45.1-44.8 45.1 19.8 45.1 44.8-19.6 44.8-45.1 44.8m0-17.6c15.2 0 25.8-11.9 25.8-27.2S445.2 74 430.1 74c-15.3 0-26 11.9-26 27.2s10.7 27.2 26 27.2M500 39.3c-6.9 0-12.7-5.7-12.7-12.7 0-6.9 5.9-12.6 12.7-12.6 7.1 0 12.6 5.7 12.6 12.6 0 7.1-5.5 12.7-12.6 12.7m-9.4 18.8h18.9v86.1H496c-3 0-5.4-2.4-5.4-5.4V58.1zM566.6 56.4c12.4 0 22.7 6.4 27.6 13.3V15.1h18.9v129.2h-13.6c-3 0-5.4-2.4-5.4-5.4v-6.2c-4.8 6.9-15.2 13.3-27.6 13.3-23.6 0-41.5-20.2-41.5-44.8.1-24.6 18-44.8 41.6-44.8m3.5 17.2c-15.3 0-25.7 12.1-25.7 27.6s10.3 27.6 25.7 27.6c15.3 0 25.7-12.1 25.7-27.6s-10.4-27.6-25.7-27.6"
    ></path>
    <path
      class="logo-android__andy-icon"
      d="m822.2 111.7c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6 9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6m-105.7 0c-5.3 0-9.6-4.3-9.6-9.6s4.3-9.6 9.6-9.6 9.6 4.3 9.6 9.6-4.3 9.6-9.6 9.6m109.1-57.6l19.2-33.1c1.1-1.9 0.4-4.3-1.5-5.4s-4.3-0.4-5.4 1.5l-19.4 33.5c-14.8-6.8-31.4-10.6-49.1-10.6s-34.4 3.8-49.2 10.5l-19.4-33.5c-1.1-1.9-3.5-2.6-5.4-1.5s-2.6 3.5-1.5 5.4l19.1 33.1c-32.8 17.9-55.3 51.1-58.6 90.4h229.7c-3.2-39.2-25.6-72.4-58.5-90.3"
    ></path>
  </symbol>
  <symbol id="ico-arrow-external" viewBox="0 0 13 13">
    <path
      d="M.8 7.4h9.3L6 11.6c-.3.3-.3.9 0 1.2.3.3.9.3 1.2 0l5.5-5.6c.3-.3.3-.9 0-1.2L7.3.3C7 0 6.4 0 6.1.3s-.3.9 0 1.2l4.1 4.2H.8c-.4-.1-.8.3-.8.8s.4.9.8.9z"
      fill="currentColor"
    ></path>
  </symbol>
  <symbol id="ico-arrow-round" viewBox="0 0 11 7">
    <path
      d="M9.576 1.333L5.333 5.576 1.091 1.333"
      fill="none"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="2"
    ></path>
  </symbol>
  <symbol id="ico-arrow-large" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path
        d="M5 13h11.17l-4.88 4.88c-.39.39-.39 1.03 0 1.42.39.39 1.02.39 1.41 0l6.59-6.59a.996.996 0 0 0 0-1.41l-6.58-6.6a.996.996 0 1 0-1.41 1.41L16.17 11H5c-.55 0-1 .45-1 1s.45 1 1 1z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="ico-close" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z"></path>
      <path
        d="M18.3 5.71a.996.996 0 0 0-1.41 0L12 10.59 7.11 5.7A.996.996 0 1 0 5.7 7.11L10.59 12 5.7 16.89a.996.996 0 1 0 1.41 1.41L12 13.41l4.89 4.89a.996.996 0 1 0 1.41-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="ico-cross" viewBox="0 0 63 63">
    <path d="M63 26.2H36.8V0H26.2v26.2H0v10.6h26.2V63h10.6V36.8H63z"></path>
  </symbol>
  <symbol id="ico-exclamation" viewBox="0 0 29 29">
    <g
      fill="none"
      fill-rule="evenodd"
      stroke="currentColor"
      transform="translate(1 1)"
    >
      <path d="M12 15h3V6h-3zm0 6h3v-3h-3z" fill="currentColor"></path>
      <circle
        cx="13.5"
        cy="13.5"
        r="13.5"
        stroke="currentColor"
        stroke-width="2"
      ></circle>
    </g>
  </symbol>
  <symbol id="ico-globe" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z"></path>
      <path
        d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95a15.65 15.65 0 0 0-1.38-3.56A8.03 8.03 0 0 1 18.92 8zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2s.06 1.34.14 2zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56A7.987 7.987 0 0 1 5.08 16zm2.95-8H5.08a7.987 7.987 0 0 1 4.33-3.56A15.65 15.65 0 0 0 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2s.07-1.35.16-2h4.68c.09.65.16 1.32.16 2s-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95a8.03 8.03 0 0 1-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2s-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="ico-hamburger" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z"></path>
      <path
        d="M4 18h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zm0-5h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1s.45 1 1 1zM3 7c0 .55.45 1 1 1h16c.55 0 1-.45 1-1s-.45-1-1-1H4c-.55 0-1 .45-1 1z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="ico-search" viewBox="0 0 24 24">
    <g fill="none" fill-rule="evenodd">
      <path d="M0 0h24v24H0z"></path>
      <path
        d="M15.5 14h-.79l-.28-.27a6.5 6.5 0 0 0 1.48-5.34c-.47-2.78-2.79-5-5.59-5.34a6.505 6.505 0 0 0-7.27 7.27c.34 2.8 2.56 5.12 5.34 5.59a6.5 6.5 0 0 0 5.34-1.48l.27.28v.79l4.25 4.25c.41.41 1.08.41 1.49 0 .41-.41.41-1.08 0-1.49L15.5 14zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="ico-skip" viewBox="0 0 24 24">
    <path d="M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"></path>
    <path d="M0 0h24v24H0z" fill="none"></path>
  </symbol>
  <symbol id="ico-stop" viewBox="0 0 24 24">
    <path d="M0 0h24v24H0z" fill="none"></path>
    <path d="M6 6h12v12H6z"></path>
  </symbol>
  <symbol id="social-blogger" viewBox="0 0 512 512">
    <rect fill="currentColor" height="512" rx="15%" width="512"></rect>
    <path
      d="M95 184c0-51 41-93 93-93h86c64 0 103 61 85 126 0 0 61-3 66 58v53c0 46-34 93-93 93H183c-49 0-88-39-88-88z"
      fill="#f3f3f3"
    ></path>
    <path
      d="M199 188h68m-74 129h133"
      stroke="currentColor"
      stroke-width="55"
    ></path>
  </symbol>
  <symbol fill="none" fill-rule="evenodd" id="social-email" viewBox="0 0 20 16">
    <path
      d="M18 0H2C.9 0 .01.9.01 2L0 14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm0 14H2V4l8 5 8-5v10zm-8-7L2 2h16l-8 5z"
      fill="currentColor"
    ></path>
  </symbol>
  <symbol id="social-facebook" viewBox="0 0 20 20">
    <g fill="none" fill-rule="evenodd">
      <path d="M-2-2h24v24H-2z"></path>
      <path
        d="M20 10.1c0-5.5-4.5-10-10-10S0 4.5 0 10.1c0 5 3.7 9.1 8.4 9.9v-7H5.9v-2.9h2.5V7.9C8.4 5.4 9.9 4 12.2 4c1.1 0 2.2.2 2.2.2v2.5h-1.3c-1.2 0-1.6.8-1.6 1.6v1.9h2.8l-.4 2.8h-2.3v7c4.7-.8 8.4-4.9 8.4-9.9z"
        fill="currentColor"
      ></path>
    </g>
  </symbol>
  <symbol id="social-instagram" viewBox="0 0 48 48">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M23.9,7.1c5.5,0,6.1,0,8.3,0.1c2,0.1,3.1,0.4,3.8,0.7c0.9,0.3,1.7,0.9,2.4,1.5c0.7,0.7,1.2,1.5,1.5,2.4 c0.3,0.7,0.6,1.8,0.7,3.8c0.1,2.2,0.1,2.8,0.1,8.3s0,6.1-0.1,8.3c-0.1,2-0.4,3.1-0.7,3.8c-0.7,1.8-2.1,3.2-3.9,3.9 c-0.7,0.3-1.8,0.6-3.8,0.7c-2.2,0.1-2.8,0.1-8.3,0.1s-6.1,0-8.3-0.1c-2-0.1-3.1-0.4-3.8-0.7c-0.9-0.3-1.7-0.9-2.4-1.5 c-0.7-0.7-1.2-1.5-1.5-2.4c-0.3-0.7-0.6-1.8-0.7-3.8c-0.1-2.2-0.1-2.8-0.1-8.3s0-6.1,0.1-8.3c0.1-2,0.4-3.1,0.7-3.8 c0.3-0.9,0.9-1.7,1.5-2.4c0.7-0.7,1.5-1.2,2.4-1.5c0.7-0.3,1.8-0.6,3.8-0.7C17.8,7.1,18.5,7.1,23.9,7.1 M23.9,3.4 c-5.6,0-6.3,0-8.5,0.1c-2.2,0.1-3.7,0.4-5,1C9.1,5,7.9,5.8,6.9,6.8c-1,1-1.9,2.3-2.4,3.6c-0.5,1.3-0.9,2.8-1,5 c-0.1,2.2-0.1,2.9-0.1,8.5s0,6.3,0.1,8.5c0.1,2.2,0.4,3.7,1,5C5,38.7,5.8,40,6.9,41c1,1,2.3,1.9,3.6,2.4c1.3,0.5,2.8,0.9,5,1 c2.2,0.1,2.9,0.1,8.5,0.1s6.3,0,8.5-0.1c2.2-0.1,3.7-0.4,5-1c2.8-1.1,4.9-3.2,6-6c0.5-1.3,0.9-2.8,1-5c0.1-2.2,0.1-2.9,0.1-8.5 s0-6.3-0.1-8.5c-0.1-2.2-0.4-3.7-1-5c-0.5-1.4-1.3-2.6-2.4-3.6c-1-1-2.3-1.9-3.6-2.4c-1.3-0.5-2.8-0.9-5-1 C30.2,3.4,29.5,3.4,23.9,3.4L23.9,3.4L23.9,3.4z"
      ></path>
      <path
        d="M23.9,13.4c-5.8,0-10.5,4.7-10.5,10.5s4.7,10.5,10.5,10.5s10.5-4.7,10.5-10.5l0,0C34.5,18.1,29.8,13.4,23.9,13.4z M23.9,30.8c-3.8,0-6.8-3.1-6.8-6.8c0-3.8,3.1-6.8,6.8-6.8c3.8,0,6.8,3.1,6.8,6.8C30.8,27.7,27.7,30.8,23.9,30.8z"
      ></path>
      <circle cx="34.9" cy="13" r="2.5"></circle>
    </g>
  </symbol>
  <symbol fill="none" fill-rule="evenodd" id="social-link" viewBox="0 0 22 10">
    <path d="M6.208 4h9.584v2H6.208V4z" fill="currentColor"></path>
    <path
      d="M16.75 0h-3.833v2h3.833c1.588 0 2.875 1.343 2.875 3s-1.287 3-2.875 3h-3.833v2h3.833c2.646 0 4.792-2.239 4.792-5s-2.146-5-4.792-5zM5.25 10h3.833V8H5.25C3.662 8 2.375 6.657 2.375 5S3.662 2 5.25 2h3.833V0H5.25C2.604 0 .458 2.239.458 5s2.146 5 4.792 5z"
      fill="currentColor"
    ></path>
  </symbol>
  <symbol id="social-twitter" viewBox="0 0 48 48">
    <g fill="currentColor">
      <path
        d="M40.9331436,11.1940288 C42.810084,10.0689342 44.2513785,8.28745345 44.9301304,6.16481389 C43.1737706,7.20644208 41.2282743,7.96298797 39.1576594,8.37075777 C37.4993523,6.6040254 35.1368481,5.5 32.5223241,5.5 C27.501861,5.5 23.4316182,9.57008073 23.4316182,14.5902197 C23.4316182,15.3026824 23.5121673,15.9965069 23.6671068,16.661807 C16.1120205,16.2827237 9.4138018,12.6636857 4.93027879,7.16397957 C4.1478016,8.50657299 3.69951412,10.0681239 3.69951412,11.7340483 C3.69951412,14.8877815 5.30449997,17.6702107 7.74366355,19.3003175 C6.25342374,19.253155 4.85183659,18.8442507 3.62609611,18.1633918 C3.62544783,18.2013163 3.62544783,18.2394029 3.62544783,18.2776516 C3.62544783,22.6820841 6.75892216,26.3562262 10.9174935,27.1912143 C10.1546268,27.3989889 9.35156666,27.5100073 8.52241311,27.5100073 C7.93668971,27.5100073 7.36717338,27.4531205 6.81224341,27.3469642 C7.96894178,30.958547 11.3260736,33.586685 15.3039361,33.660103 C12.1928276,36.0981321 8.27314842,37.5514198 4.01425536,37.5514198 C3.28056144,37.5514198 2.5569159,37.5084711 1.8457498,37.4245184 C5.86866797,40.0037111 10.6469975,41.5085373 15.780586,41.5085373 C32.5010928,41.5085373 41.6444717,27.6568433 41.6444717,15.6443274 C41.6444717,15.2501715 41.6357199,14.8581225 41.6182163,14.4683426 C43.3941867,13.1866877 44.9354788,11.5855916 46.1542502,9.76262068 C44.5239813,10.4856179 42.7719974,10.974261 40.9331436,11.1940288 Z"
      ></path>
    </g>
  </symbol>
  <symbol id="social-youtube" viewBox="0 0 48 48">
    <g fill="currentColor">
      <path
        d="M47.48 13.21s-.46-3.3-1.9-4.74c-1.82-1.92-3.86-1.92-4.8-2.04C34.08 5.94 24 6 24 6s-10.04-.06-16.74.42c-.92.12-2.96.12-4.78 2.04C1.04 9.9.56 13.2.56 13.2S.08 17.09 0 20.96v4.05c.08 3.88.56 7.75.56 7.75s.48 3.3 1.92 4.76c1.82 1.9 4.2 1.84 5.28 2.04 3.76.36 15.82.44 16.24.44 0 0 10.1.02 16.8-.46.92-.12 2.96-.12 4.78-2.04 1.44-1.44 1.92-4.74 1.92-4.74s.48-3.88.5-7.75v-4.05c-.04-3.87-.52-7.75-.52-7.75zM19.14 30V15.98L32 23.26 19.14 30z"
      ></path>
      <path d="M0 0h47.99v48H0z" fill="none"></path>
    </g>
  </symbol>

  <symbol id="apple-badge" viewBox="0 0 119.66407 40">
    <g>
      <g>
        <g>
          <path
            d="M110.13477,0H9.53468c-.3667,0-.729,0-1.09473.002-.30615.002-.60986.00781-.91895.0127A13.21476,13.21476,0,0,0,5.5171.19141a6.66509,6.66509,0,0,0-1.90088.627A6.43779,6.43779,0,0,0,1.99757,1.99707,6.25844,6.25844,0,0,0,.81935,3.61816a6.60119,6.60119,0,0,0-.625,1.90332,12.993,12.993,0,0,0-.1792,2.002C.00587,7.83008.00489,8.1377,0,8.44434V31.5586c.00489.3105.00587.6113.01515.9219a12.99232,12.99232,0,0,0,.1792,2.0019,6.58756,6.58756,0,0,0,.625,1.9043A6.20778,6.20778,0,0,0,1.99757,38.001a6.27445,6.27445,0,0,0,1.61865,1.1787,6.70082,6.70082,0,0,0,1.90088.6308,13.45514,13.45514,0,0,0,2.0039.1768c.30909.0068.6128.0107.91895.0107C8.80567,40,9.168,40,9.53468,40H110.13477c.3594,0,.7246,0,1.084-.002.3047,0,.6172-.0039.9219-.0107a13.279,13.279,0,0,0,2-.1768,6.80432,6.80432,0,0,0,1.9082-.6308,6.27742,6.27742,0,0,0,1.6172-1.1787,6.39482,6.39482,0,0,0,1.1816-1.6143,6.60413,6.60413,0,0,0,.6191-1.9043,13.50643,13.50643,0,0,0,.1856-2.0019c.0039-.3106.0039-.6114.0039-.9219.0078-.3633.0078-.7246.0078-1.0938V9.53613c0-.36621,0-.72949-.0078-1.09179,0-.30664,0-.61426-.0039-.9209a13.5071,13.5071,0,0,0-.1856-2.002,6.6177,6.6177,0,0,0-.6191-1.90332,6.46619,6.46619,0,0,0-2.7988-2.7998,6.76754,6.76754,0,0,0-1.9082-.627,13.04394,13.04394,0,0,0-2-.17676c-.3047-.00488-.6172-.01074-.9219-.01269-.3594-.002-.7246-.002-1.084-.002Z"
            style="fill: #a6a6a6"
          />
          <path
            d="M8.44483,39.125c-.30468,0-.602-.0039-.90429-.0107a12.68714,12.68714,0,0,1-1.86914-.1631,5.88381,5.88381,0,0,1-1.65674-.5479,5.40573,5.40573,0,0,1-1.397-1.0166,5.32082,5.32082,0,0,1-1.02051-1.3965,5.72186,5.72186,0,0,1-.543-1.6572,12.41351,12.41351,0,0,1-.1665-1.875c-.00634-.2109-.01464-.9131-.01464-.9131V8.44434S.88185,7.75293.8877,7.5498a12.37039,12.37039,0,0,1,.16553-1.87207,5.7555,5.7555,0,0,1,.54346-1.6621A5.37349,5.37349,0,0,1,2.61183,2.61768,5.56543,5.56543,0,0,1,4.01417,1.59521a5.82309,5.82309,0,0,1,1.65332-.54394A12.58589,12.58589,0,0,1,7.543.88721L8.44532.875H111.21387l.9131.0127a12.38493,12.38493,0,0,1,1.8584.16259,5.93833,5.93833,0,0,1,1.6709.54785,5.59374,5.59374,0,0,1,2.415,2.41993,5.76267,5.76267,0,0,1,.5352,1.64892,12.995,12.995,0,0,1,.1738,1.88721c.0029.2832.0029.5874.0029.89014.0079.375.0079.73193.0079,1.09179V30.4648c0,.3633,0,.7178-.0079,1.0752,0,.3252,0,.6231-.0039.9297a12.73126,12.73126,0,0,1-.1709,1.8535,5.739,5.739,0,0,1-.54,1.67,5.48029,5.48029,0,0,1-1.0156,1.3857,5.4129,5.4129,0,0,1-1.3994,1.0225,5.86168,5.86168,0,0,1-1.668.5498,12.54218,12.54218,0,0,1-1.8692.1631c-.2929.0068-.5996.0107-.8974.0107l-1.084.002Z"
          />
        </g>
        <g data-name="&lt;Group&gt;" id="_Group_">
          <g data-name="&lt;Group&gt;" id="_Group_2">
            <g data-name="&lt;Group&gt;" id="_Group_3">
              <path
                d="M24.76888,20.30068a4.94881,4.94881,0,0,1,2.35656-4.15206,5.06566,5.06566,0,0,0-3.99116-2.15768c-1.67924-.17626-3.30719,1.00483-4.1629,1.00483-.87227,0-2.18977-.98733-3.6085-.95814a5.31529,5.31529,0,0,0-4.47292,2.72787c-1.934,3.34842-.49141,8.26947,1.3612,10.97608.9269,1.32535,2.01018,2.8058,3.42763,2.7533,1.38706-.05753,1.9051-.88448,3.5794-.88448,1.65876,0,2.14479.88448,3.591.8511,1.48838-.02416,2.42613-1.33124,3.32051-2.66914a10.962,10.962,0,0,0,1.51842-3.09251A4.78205,4.78205,0,0,1,24.76888,20.30068Z"
                data-name="&lt;Path&gt;"
                id="_Path_"
                style="fill: #fff"
              />
              <path
                d="M22.03725,12.21089a4.87248,4.87248,0,0,0,1.11452-3.49062,4.95746,4.95746,0,0,0-3.20758,1.65961,4.63634,4.63634,0,0,0-1.14371,3.36139A4.09905,4.09905,0,0,0,22.03725,12.21089Z"
                data-name="&lt;Path&gt;"
                id="_Path_2"
                style="fill: #fff"
              />
            </g>
          </g>
          <g>
            <path
              d="M42.30227,27.13965h-4.7334l-1.13672,3.35645H34.42727l4.4834-12.418h2.083l4.4834,12.418H43.438ZM38.0591,25.59082h3.752l-1.84961-5.44727h-.05176Z"
              style="fill: #fff"
            />
            <path
              d="M55.15969,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H48.4302v1.50586h.03418a3.21162,3.21162,0,0,1,2.88281-1.60059C53.645,21.34766,55.15969,23.16406,55.15969,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C52.30227,29.01563,53.24953,27.81934,53.24953,25.96973Z"
              style="fill: #fff"
            />
            <path
              d="M65.12453,25.96973c0,2.81348-1.50586,4.62109-3.77832,4.62109a3.0693,3.0693,0,0,1-2.84863-1.584h-.043v4.48438h-1.8584V21.44238H58.395v1.50586h.03418A3.21162,3.21162,0,0,1,61.312,21.34766C63.60988,21.34766,65.12453,23.16406,65.12453,25.96973Zm-1.91016,0c0-1.833-.94727-3.03809-2.39258-3.03809-1.41992,0-2.375,1.23047-2.375,3.03809,0,1.82422.95508,3.0459,2.375,3.0459C62.26711,29.01563,63.21438,27.81934,63.21438,25.96973Z"
              style="fill: #fff"
            />
            <path
              d="M71.71047,27.03613c.1377,1.23145,1.334,2.04,2.96875,2.04,1.56641,0,2.69336-.80859,2.69336-1.91895,0-.96387-.67969-1.541-2.28906-1.93652l-1.60937-.3877c-2.28027-.55078-3.33887-1.61719-3.33887-3.34766,0-2.14258,1.86719-3.61426,4.51855-3.61426,2.624,0,4.42285,1.47168,4.4834,3.61426h-1.876c-.1123-1.23926-1.13672-1.9873-2.63379-1.9873s-2.52148.75684-2.52148,1.8584c0,.87793.6543,1.39453,2.25488,1.79l1.36816.33594c2.54785.60254,3.60645,1.626,3.60645,3.44238,0,2.32324-1.85059,3.77832-4.79395,3.77832-2.75391,0-4.61328-1.4209-4.7334-3.667Z"
              style="fill: #fff"
            />
            <path
              d="M83.34621,19.2998v2.14258h1.72168v1.47168H83.34621v4.99121c0,.77539.34473,1.13672,1.10156,1.13672a5.80752,5.80752,0,0,0,.61133-.043v1.46289a5.10351,5.10351,0,0,1-1.03223.08594c-1.833,0-2.54785-.68848-2.54785-2.44434V22.91406H80.16262V21.44238H81.479V19.2998Z"
              style="fill: #fff"
            />
            <path
              d="M86.065,25.96973c0-2.84863,1.67773-4.63867,4.29395-4.63867,2.625,0,4.29492,1.79,4.29492,4.63867,0,2.85645-1.66113,4.63867-4.29492,4.63867C87.72609,30.6084,86.065,28.82617,86.065,25.96973Zm6.69531,0c0-1.9541-.89551-3.10742-2.40137-3.10742s-2.40039,1.16211-2.40039,3.10742c0,1.96191.89453,3.10645,2.40039,3.10645S92.76027,27.93164,92.76027,25.96973Z"
              style="fill: #fff"
            />
            <path
              d="M96.18606,21.44238h1.77246v1.541h.043a2.1594,2.1594,0,0,1,2.17773-1.63574,2.86616,2.86616,0,0,1,.63672.06934v1.73828a2.59794,2.59794,0,0,0-.835-.1123,1.87264,1.87264,0,0,0-1.93652,2.083v5.37012h-1.8584Z"
              style="fill: #fff"
            />
            <path
              d="M109.3843,27.83691c-.25,1.64355-1.85059,2.77148-3.89844,2.77148-2.63379,0-4.26855-1.76465-4.26855-4.5957,0-2.83984,1.64355-4.68164,4.19043-4.68164,2.50488,0,4.08008,1.7207,4.08008,4.46582v.63672h-6.39453v.1123a2.358,2.358,0,0,0,2.43555,2.56445,2.04834,2.04834,0,0,0,2.09082-1.27344Zm-6.28223-2.70215h4.52637a2.1773,2.1773,0,0,0-2.2207-2.29785A2.292,2.292,0,0,0,103.10207,25.13477Z"
              style="fill: #fff"
            />
          </g>
        </g>
      </g>
      <g data-name="&lt;Group&gt;" id="_Group_4">
        <g>
          <path
            d="M37.82619,8.731a2.63964,2.63964,0,0,1,2.80762,2.96484c0,1.90625-1.03027,3.002-2.80762,3.002H35.67092V8.731Zm-1.22852,5.123h1.125a1.87588,1.87588,0,0,0,1.96777-2.146,1.881,1.881,0,0,0-1.96777-2.13379h-1.125Z"
            style="fill: #fff"
          />
          <path
            d="M41.68068,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C44.57522,13.99463,45.01369,13.42432,45.01369,12.44434Z"
            style="fill: #fff"
          />
          <path
            d="M51.57326,14.69775h-.92187l-.93066-3.31641h-.07031l-.92676,3.31641h-.91309l-1.24121-4.50293h.90137l.80664,3.436h.06641l.92578-3.436h.85254l.92578,3.436h.07031l.80273-3.436h.88867Z"
            style="fill: #fff"
          />
          <path
            d="M53.85354,10.19482H54.709v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915h-.88867V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z"
            style="fill: #fff"
          />
          <path
            d="M59.09377,8.437h.88867v6.26074h-.88867Z"
            style="fill: #fff"
          />
          <path
            d="M61.21779,12.44434a2.13346,2.13346,0,1,1,4.24756,0,2.1338,2.1338,0,1,1-4.24756,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C64.11232,13.99463,64.5508,13.42432,64.5508,12.44434Z"
            style="fill: #fff"
          />
          <path
            d="M66.4009,13.42432c0-.81055.60352-1.27783,1.6748-1.34424l1.21973-.07031v-.38867c0-.47559-.31445-.74414-.92187-.74414-.49609,0-.83984.18213-.93848.50049h-.86035c.09082-.77344.81836-1.26953,1.83984-1.26953,1.12891,0,1.76563.562,1.76563,1.51318v3.07666h-.85547v-.63281h-.07031a1.515,1.515,0,0,1-1.35254.707A1.36026,1.36026,0,0,1,66.4009,13.42432Zm2.89453-.38477v-.37646l-1.09961.07031c-.62012.0415-.90137.25244-.90137.64941,0,.40527.35156.64111.835.64111A1.0615,1.0615,0,0,0,69.29543,13.03955Z"
            style="fill: #fff"
          />
          <path
            d="M71.34816,12.44434c0-1.42285.73145-2.32422,1.86914-2.32422a1.484,1.484,0,0,1,1.38086.79h.06641V8.437h.88867v6.26074h-.85156v-.71143h-.07031a1.56284,1.56284,0,0,1-1.41406.78564C72.0718,14.772,71.34816,13.87061,71.34816,12.44434Zm.918,0c0,.95508.4502,1.52979,1.20313,1.52979.749,0,1.21191-.583,1.21191-1.52588,0-.93848-.46777-1.52979-1.21191-1.52979C72.72121,10.91846,72.26613,11.49707,72.26613,12.44434Z"
            style="fill: #fff"
          />
          <path
            d="M79.23,12.44434a2.13323,2.13323,0,1,1,4.24707,0,2.13358,2.13358,0,1,1-4.24707,0Zm3.333,0c0-.97607-.43848-1.54687-1.208-1.54687-.77246,0-1.207.5708-1.207,1.54688,0,.98389.43457,1.55029,1.207,1.55029C82.12453,13.99463,82.563,13.42432,82.563,12.44434Z"
            style="fill: #fff"
          />
          <path
            d="M84.66945,10.19482h.85547v.71533h.06641a1.348,1.348,0,0,1,1.34375-.80225,1.46456,1.46456,0,0,1,1.55859,1.6748v2.915H87.605V12.00586c0-.72363-.31445-1.0835-.97168-1.0835a1.03294,1.03294,0,0,0-1.0752,1.14111v2.63428h-.88867Z"
            style="fill: #fff"
          />
          <path
            d="M93.51516,9.07373v1.1416h.97559v.74854h-.97559V13.2793c0,.47168.19434.67822.63672.67822a2.96657,2.96657,0,0,0,.33887-.02051v.74023a2.9155,2.9155,0,0,1-.4834.04541c-.98828,0-1.38184-.34766-1.38184-1.21582v-2.543h-.71484v-.74854h.71484V9.07373Z"
            style="fill: #fff"
          />
          <path
            d="M95.70461,8.437h.88086v2.48145h.07031a1.3856,1.3856,0,0,1,1.373-.80664,1.48339,1.48339,0,0,1,1.55078,1.67871v2.90723H98.69v-2.688c0-.71924-.335-1.0835-.96289-1.0835a1.05194,1.05194,0,0,0-1.13379,1.1416v2.62988h-.88867Z"
            style="fill: #fff"
          />
          <path
            d="M104.76125,13.48193a1.828,1.828,0,0,1-1.95117,1.30273A2.04531,2.04531,0,0,1,100.73,12.46045a2.07685,2.07685,0,0,1,2.07617-2.35254c1.25293,0,2.00879.856,2.00879,2.27V12.688h-3.17969v.0498a1.1902,1.1902,0,0,0,1.19922,1.29,1.07934,1.07934,0,0,0,1.07129-.5459Zm-3.126-1.45117h2.27441a1.08647,1.08647,0,0,0-1.1084-1.1665A1.15162,1.15162,0,0,0,101.63527,12.03076Z"
            style="fill: #fff"
          />
        </g>
      </g>
    </g>
  </symbol>
</svg>
